import { render, staticRenderFns } from "./CourseSet.vue?vue&type=template&id=4c384bd8&scoped=true&"
import script from "./CourseSet.vue?vue&type=script&lang=js&"
export * from "./CourseSet.vue?vue&type=script&lang=js&"
import style0 from "./CourseSet.vue?vue&type=style&index=0&id=4c384bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c384bd8",
  null
  
)

export default component.exports